/** True when an authenticated user still needs to provide date of birth. */
export const userNeedsDob = (user) => {
  if (!user) return false;
  const { dob } = user;
  return dob == null || dob === '';
};

/** Shared DOB validation (matches register flow: required, min age 13). */
export const validateDob = (dobValue) => {
  if (!dobValue) {
    return 'Date of birth is required.';
  }

  const dob = new Date(dobValue);
  if (Number.isNaN(dob.getTime())) {
    return 'Please enter a valid date of birth.';
  }

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age -= 1;
  }

  if (age < 13) {
    return 'You must be at least 13 years old.';
  }

  return null;
};
